import { AxiosResponse } from 'axios';

import apiRoutes from 'src/routes/apiRoutes';
import Fetcher from 'src/utils/fetcher';
import WorkExperience from 'src/types/resources/WorkExperience';
import { WorkExperienceFormDataToSubmit } from 'src/forms/talents/workExperience';

export type CreateParams = WorkExperienceFormDataToSubmit;
export type UpdateParams = {
  id: number;
  params: WorkExperienceFormDataToSubmit;
};
export type DeleteParams = {
  id: number;
};

export default {
  index(): Promise<{ results: WorkExperience[] }> {
    const url = apiRoutes.talent.workExperiencesPath();
    return Fetcher.get(url);
  },
  create(params: CreateParams): Promise<AxiosResponse> {
    const url = apiRoutes.talent.workExperiencesPath();
    return Fetcher.post(url, params);
  },
  read(id: number): Promise<AxiosResponse> {
    const url = apiRoutes.talent.workExperiencePath(id);
    return Fetcher.get(url);
  },
  update({ id, params }: UpdateParams): Promise<AxiosResponse> {
    const url = apiRoutes.talent.workExperiencePath(id);
    return Fetcher.patch(url, params);
  },
  delete({ id }: DeleteParams): Promise<AxiosResponse> {
    const url = apiRoutes.talent.workExperiencePath(id);
    return Fetcher.delete(url);
  },
};
